import ProcessFlow from "./ProcessFlow";
import YieldEfficiency from "./YieldEfficiency";
import "./dashboard-sections.css";
import { useGetBiggestDailyQuery } from "../dashBoardApi";
import { getCurrentDate, makeLotNumber, makePriorLotNumber } from "../../../helpers/Utils";
import { useState } from "react";

const BiggestDaily = () => {
  const [currentDate] = useState(getCurrentDate("YYYY-MM-DD"));

  const { data: biggestDailyData, isLoading: biggestDailyLoading } = useGetBiggestDailyQuery({
    date: currentDate,
    priorLotNumber: makePriorLotNumber(currentDate),
    currentLotNumber: makeLotNumber(),
  });

  const data = biggestDailyData?.data;

  return (
    <div className="db-section">
      <div className="bd-two-col">
        <ProcessFlow isLoading={biggestDailyLoading} data={data} />
        <YieldEfficiency isLoading={biggestDailyLoading} data={data} />
      </div>
    </div>
  );
};

export default BiggestDaily;
